import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-popover-stripe',
  templateUrl: './popover-stripe.component.html',
  styleUrls: ['./popover-stripe.component.scss'],
})
export class PopoverStripeComponent implements OnInit {

  props: any;

  constructor() { }

  ngOnInit() {}

}
